import SeismicForm, { DeresmaForm } from '@/models/SeismicForm'
import Inspector from '@/models/Inspector'
import Team from '@/models/Team'

export interface FormsStore {
  // IndexedDb parameters:
  indexedDBName: string
  indexedDBVersion: number
  indexedDBRequest?: any
  indexedDBResult?: any
  appTitle: string
  // Business data:
  seismicForms: Array<SeismicForm>
  selectedCampaignSeismicForms: Array<SeismicForm>
  // eslint disable-next-line
  selectedCampaign: string | any
  selectedSeismicForm: null | SeismicForm
  inspectors: Array<Inspector>
  teams: Array<Team>
  selectedInspectors: Array<Inspector>

  numberFilter: string,
  batFilter: string,
  localFilter: string,
  commentFilter: string,
  statusFilter: string,
  dateFilter: string,

  // Forms to show as tabs in the UI
  pinnedForms: Array<SeismicForm>

  // Technical global values
  isPrintablePDFMode: boolean

  // Campaign Import stuffs
  uploadedFileName: undefined | string
  uploadedFileContent: undefined | JSON

}
export enum FormsStatus {
  todo = 'A faire',
  pending = 'En cours',
  otherTeam = 'Autre équipe',
  blocked = 'Bloqué',
  done = 'Terminé',
  other = 'Autre tablette'
}
